import React from "react";
import Select from "react-select";

export default function CustomSelect({
  label,
  value,
  onChange,
  options,
  placeholder = "Select...",
  error,
}) {
  return (
    <div className="w-full">
      {label && (
        <label className="font-semibold text-gray-900 mb-2 block">
          {label}
        </label>
      )}

      <Select
        value={options.find((opt) => opt.value === value) || null}
        onChange={(opt) => onChange(opt?.value)}
        options={options}
        placeholder={placeholder}
        classNamePrefix="rs"
        components={{ IndicatorSeparator: () => null }} // 👈 REMOVE THE |
        styles={{
          control: (base, state) => ({
            ...base,
            backgroundColor: "#F7F9FA",
            borderColor: state.isFocused ? "#1FADC6" : "#D9D9D9",
            borderRadius: 12,
            minHeight: 48,
            cursor: "pointer",
            boxShadow: state.isFocused
              ? "0 0 0 2px rgba(31,173,198,0.3)"
              : "none",
            "&:hover": { borderColor: "#1FADC6" },
          }),
          menu: (base) => ({
            ...base,
            borderRadius: 12,
            overflow: "hidden",
            zIndex: 9999,
          }),
          option: (base, state) => ({
            ...base,
            padding: "10px 12px",
            backgroundColor: state.isSelected
              ? "#1FADC6"
              : state.isFocused
              ? "#D8F7FF"
              : "white",
            color: state.isSelected ? "white" : "#333",
            cursor: "pointer",
          }),
        }}
      />

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
